import React, { useMemo } from 'react'

import { getNativeChainIdForCurrency } from '../../config/native'
import { useTokenProfile } from '@/data/marketApi/hooks/useTokenProfile'
import { NATIVE_TOKEN_ADDRESS } from '@sirius-cybernetics-42/product-config'
import { Currency, Token } from '../../sdk'
import { TokenMediaImage } from '../TokenMediaImage'

/** Dirección de catálogo/perfil CMS para resolver iconos (nativo → 0x0). */
export function resolveCurrencyLogoAddress(currency: Currency | undefined): string | undefined {
  if (!currency) return undefined
  if (getNativeChainIdForCurrency(currency) !== undefined) {
    return NATIVE_TOKEN_ADDRESS
  }
  if (currency instanceof Token) {
    return currency.address
  }
  return undefined
}

export default function CurrencyLogo({
  currency,
  size = '24px',
  style,
  className,
}: {
  currency?: Currency
  size?: string
  style?: React.CSSProperties
  className?: string
}) {
  const address = useMemo(() => resolveCurrencyLogoAddress(currency), [currency])
  const { data: profile } = useTokenProfile(address)

  if (!currency) return null

  return (
    <TokenMediaImage
      src={profile?.iconUrl}
      address={address}
      variant="icon"
      alt={`${currency.symbol ?? 'token'} logo`}
      className={className}
      style={{
        width: size,
        height: size,
        boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.075)',
        borderRadius: 24,
        objectFit: 'cover',
        flexShrink: 0,
        ...style,
      }}
    />
  )
}
